import { getApiUrl, getAuthHeaders } from './api-client';

/**
 * GET /admin/lead-requests
 * Получить список заявок
 */
export async function getAdminLeadRequests(params = {}) {
    try {
        const apiUrl = getApiUrl();
        if (!apiUrl) {
            return { items: [], total: 0, page: 1, limit: 50, totalPages: 0 };
        }

        const queryParams = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined && value !== null && value !== '') {
                const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
                queryParams.append(key, stringValue);
            }
        }

        const queryString = queryParams.toString();
        const url = `${apiUrl}/admin/lead-requests${queryString ? `?${queryString}` : ''}`;

        const response = await fetch(url, {
            cache: 'no-store',
            headers: {
                'Accept': 'application/json',
                ...getAuthHeaders(),
            }
        });

        if (!response.ok) {
            console.error(`Failed to fetch lead requests. Status: ${response.status}`);
            return { items: [], total: 0, page: 1, limit: 50, totalPages: 0 };
        }

        const data = await response.json();
        return {
            items: data.items || [],
            total: data.total || 0,
            page: data.page || 1,
            limit: data.limit || 50,
            totalPages: data.totalPages || Math.ceil((data.total || 0) / (data.limit || 50)),
            meta: data
        };
    } catch (error) {
        console.error("Error fetching admin lead requests:", error);
        return { items: [], total: 0, page: 1, limit: 50, totalPages: 0 };
    }
}

/**
 * GET /admin/lead-requests/{requestId}
 * Получить заявку по ID
 */
export async function getAdminLeadRequestById(requestId, params = {}) {
    try {
        const apiUrl = getApiUrl();
        if (!apiUrl) {
            throw new Error('API URL is not configured');
        }

        const queryParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined && value !== null && value !== '') {
                queryParams.append(key, String(value));
            }
        }

        const queryString = queryParams.toString();
        const url = `${apiUrl}/admin/lead-requests/${requestId}${queryString ? `?${queryString}` : ''}`;


        const response = await fetch(url, {
            cache: 'no-store',
            headers: {
                'Accept': 'application/json',
                ...getAuthHeaders(),
            }
        });

        const data = await response.json();

        if (!response.ok) {
            const errorMsg = data?.message || `Failed to fetch lead request. Status: ${response.status}`;
            console.error(`Error fetching lead request by id:`, errorMsg, data);
            throw new Error(errorMsg);
        }

        return data;
    } catch (error) {
        console.error("Error fetching admin lead request by id:", error);
        throw error;
    }
}

/**
 * PATCH /admin/lead-requests/{requestId}/status
 * Обновить статус заявки
 */
export async function updateAdminLeadRequestStatus(requestId, status) {
    try {
        const apiUrl = getApiUrl();
        if (!apiUrl) {
            return null;
        }

        const response = await fetch(`${apiUrl}/admin/lead-requests/${requestId}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...getAuthHeaders(),
            },
            body: JSON.stringify({ status }),
        });

        const data = await response.json();

        if (!response.ok) {
            console.error(`Failed to update lead request status. Status: ${response.status}`, data);
            return { error: true, ...data };
        }

        return data;
    } catch (error) {
        console.error("Error updating admin lead request status:", error);
        return { error: true, message: error.message };
    }
}

/**
 * DELETE /admin/lead-requests/{requestId}
 * Удалить заявку
 */
export async function deleteAdminLeadRequest(requestId) {
    try {
        const apiUrl = getApiUrl();
        if (!apiUrl) {
            return null;
        }

        const response = await fetch(`${apiUrl}/admin/lead-requests/${requestId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                ...getAuthHeaders(),
            },
        });

        if (response.status === 204) {
            return { ok: true };
        }

        const data = await response.json();

        if (!response.ok) {
            console.error(`Failed to delete lead request. Status: ${response.status}`, data);
            return { error: true, ...data };
        }

        return data;
    } catch (error) {
        console.error("Error deleting admin lead request:", error);
        return { error: true, message: error.message };
    }
}
